module.exports = __webpack_public_path__ + "img/course69_curriculum.b841327c.png";